import { gql } from "@apollo/client";

export const UPDATE_CONTACT_REQUEST = gql`
  mutation updateContactInfo($updateContactInfoInput: UpdateContactInfoInput!) {
    updateContactInfo(updateContactInfoInput: $updateContactInfoInput) {
      status
    }
  }
`